const m00Section = {
  id: 'm00',
  name: '2022ScoresheetM00Sub1Label',
  description: 'm00sub1Label',
  fields: [
    {
      scoring: '2022ScoresheetM00Sub2Label',
      id: 'm00_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
  ]
}

export default m00Section;